
import React from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import Projects from './pages/Projects';
// import Home from './pages/Home'; 
import About from './pages/About';
import Contact from './pages/Contact';
import Skills from './pages/Skills';
import Experience from './pages/Experience';
import HomePage from './pages/HomePage';


const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomePage />
    },
    {
      path: "/home",
      element: <HomePage />
    },
    {
      path: "/contact",
      element: <Contact />
    },
    {
      path: "/about",
      element: <About />
    },
    {
      path: "/projects",
      element: <Projects />
    },
    {
      path: "/skills",
      element: <>
        <Skills />
        {/* <Certificate/> */}
      </>
    },
    {
      path: "/experience",
      element: <Experience />
    },
  ]);

  return (
    <div>

      <RouterProvider router={router} />
    </div>
  )
}

export default App